import { useCallback } from 'react';

import { PatientSimple } from '@dreryk/egabinet-patient-frontend-api';

import { useBoolean } from '@dreryk/react-common';
import { ButtonVariant } from '@dreryk/react-components';

import { translationKeys } from './translations';
import { PatientSimpleCreateModal } from './PatientSimpleCreateModal';
import { StyledPatientSimpleCreateAction } from './PatientSimpleCreateAction.styled';

type PatientSimpleCreateActionProps = {
   readonly onSuccess: (patient: PatientSimple) => void;
};

export const PatientSimpleCreateAction = (props: PatientSimpleCreateActionProps): JSX.Element => {
   const [{ setTrue: openModal, setFalse: closeModal }, modalOpened] = useBoolean(false);

   const handleSuccess = useCallback(
      (patient: PatientSimple): void => {
         props.onSuccess(patient);
         closeModal();
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [closeModal, props.onSuccess]
   );

   return (
      <>
         <StyledPatientSimpleCreateAction
            testId={'createPatient'}
            label={translationKeys.addNewPatient}
            onClick={openModal}
            type={'button'}
            variant={ButtonVariant.SECONDARY}
         />
         {modalOpened ? <PatientSimpleCreateModal onClose={closeModal} onSuccess={handleSuccess} /> : null}
      </>
   );
};
